import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  checkPermision,
  dateDefault,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";
// import { UserCreate } from "./UserCreate";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { FormHelperText } from "@material-ui/core";
import { addBooking, addInbound, selectLoading } from "./bookingSlice";
import { Autocomplete } from "@material-ui/lab";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import { ModalClientRadio } from "./ModalClientRadio";
import { ModalLocationMasterRadio } from "../inbound/ModalLocationMasterRadio";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { fetchClient } from "../client/clientSlice";
import { fetchParty } from "../party/partySlice";
import { fetchLocationMaster } from "../location/locationSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const BookingCreate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataDelivery = useSelector(selectParameter);

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchParameter({
          paramgroup_code: "DELIVERY_ARRANGEMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );

      await dispatch(
        fetchClient({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParty({
          party_setting: "CONSIGNEE",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchLocationMaster({
          locationmaster_type: "SEA_PORT",
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    booking_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    request_shipping_date: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    request_arrival_date: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    consignee: {
      value: "",
      error: false,
      required: "N",
    },
    consignee_name: {
      value: "",
      error: false,
      required: "N",
    },
    delivery_arrangement: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
    part_of_loading: {
      value: "",
      error: false,
      required: "N",
    },

    part_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      client: formValues.client.value,
      consignee: formValues.consignee.value,
      booking_date: formValues.booking_date.value,
      request_shipping_date: formValues.request_shipping_date.value,
      delivery_arrangement: formValues.delivery_arrangement.value,
      request_arrival_date: formValues.request_arrival_date.value,
    };

    try {
      const response = await dispatch(addBooking(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);

        await history.push(
          `/outbound/booking/edit/${response.payload.data.data.booking_id}`
        );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const deliveryOptions = dataDelivery.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeDelivery = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["delivery_arrangement"]: {
        ...formValues["delivery_arrangement"],
        value,
      },
    });
  };

  const indexDelivery = deliveryOptions.findIndex(
    (obj) => obj.value === formValues.delivery_arrangement.value
  );

  // modal

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              {/* Basic Detail */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Client"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.client_name.value}
                          readOnly
                          error={formValues.client.error}
                          helperText={
                            formValues.client.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowClient(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.client_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["client"]: {
                                  ...formValues["client"],
                                  value: "",
                                },
                                ["client_name"]: {
                                  ...formValues["client_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Booking Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="booking_date"
                          value={formValues.booking_date.value}
                          onChange={handleChange}
                          error={formValues.booking_date.error}
                          helperText={
                            formValues.booking_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Request Shipping Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="request_shipping_date"
                          value={formValues.request_shipping_date.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Request Arrival Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="request_arrival_date"
                          value={formValues.request_arrival_date.value}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Consignee"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          value={formValues.consignee_name.value}
                          readOnly
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setShowShipper(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.consignee_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["consignee"]: {
                                  ...formValues["consignee"],
                                  value: "",
                                },
                                ["consignee_name"]: {
                                  ...formValues["consignee_name"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <Autocomplete
                          disablePortal
                          label="Delivery Arrangement"
                          name="Delivery Arrangement"
                          options={deliveryOptions}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          value={
                            deliveryOptions.find(
                              (option) =>
                                option.value ===
                                formValues.delivery_arrangement.value
                            ) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue === null) {
                              setFormValues({
                                ...formValues,
                                ["delivery_arrangement"]: {
                                  ...formValues["delivery_arrangement"],
                                  value: "",
                                },
                              });
                            } else {
                              setFormValues({
                                ...formValues,
                                ["delivery_arrangement"]: {
                                  ...formValues["delivery_arrangement"],
                                  value: newValue.value,
                                },
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <RedditTextField
                              className={classes.margin}
                              {...params}
                              label="Delivery Arrangement"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="delivery_arrangement"
                              
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* handleSave */}
                <Row className="mt-6 justify-content-end">
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Row>
              </div>
            </ThemeProvider>
          </CardBody>
        </Card>

        {/* Modal Create */}

        <ModalClientRadio
          isOpen={showClient}
          setShow={setShowClient}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
        />
        <ModalLocationMasterRadio
          isOpen={showLocationMaster}
          setShow={setShowLocationMaster}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
          typeLocation={typeLocation}
          setTypeLocation={setTypeLocation}
        />

        <ModalPartyRadio
          isOpen={showShipper}
          setShow={setShowShipper}
          setFormValues={setFormValues}
          formValues={formValues}
          setFields={setFields}
          fields={fields}
        />
      </div>
    </>
  );
};
